import { gql } from "@apollo/client";

import { addAuthVars } from "@teamrota/authlib";

export default addAuthVars(gql`
  query fetchMemberTimesheetsCount($memberId: ID!) {
    memberTimesheetsCount(memberId: $memberId) {
      totalCount
    }
  }
`);
